import { useEffect, useMemo, useState } from 'react';
import IntroOnboardingStep from './steps/IntroOnboardingStep';
import VerifyYourNumber from './steps/VerifyYourNumber';
import PhoneNumber from './steps/PhoneNumber';
import EnterYourDetails from './steps/EnterYourDetails';
import SelectYourAvailability from './steps/SelectYourAvailability';
import { useNavigate } from 'react-router-dom';

enum OnboardingStep {
  Intro = 'intro',
  PhoneNumber = 'phone-number',
  VerifyYourNumber = 'verify-your-number',
  EnterYourDetails = 'enter-your-details',
  SelectYourAvailability = 'select-your-availability',
}

const OnboardingPage = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<OnboardingStep>(
    OnboardingStep.Intro,
  );
  const [onboardingProgress, setOnboardingProgress] = useState<number>(0);
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [userData, setUserData] = useState<{
    name: string;
    userName: string;
    photoURL: string | null;
  }>({
    name: '',
    userName: '',
    photoURL: null,
  });

  const progressBar = useMemo(() => {
    switch (currentStep) {
      case OnboardingStep.Intro:
        return 0;
      case OnboardingStep.PhoneNumber:
        return 20;
      case OnboardingStep.VerifyYourNumber:
        return 40;
      case OnboardingStep.EnterYourDetails:
        return 60;
      case OnboardingStep.SelectYourAvailability:
        return 80;
    }
  }, [currentStep]);

  const handleUserDataChange = (data: Partial<typeof userData>) => {
    setUserData((prev) => ({ ...prev, ...data }));
  };
  useEffect(() => {
    setTimeout(() => {
      setOnboardingProgress(progressBar);
    }, 1);
  }, [currentStep]);

  return (
    <>
      {currentStep === OnboardingStep.Intro && (
        <IntroOnboardingStep
          onStartClick={() => setCurrentStep(OnboardingStep.PhoneNumber)}
          onLoginClick={() => navigate('/auth/login')}
        />
      )}
      {currentStep === OnboardingStep.PhoneNumber && (
        <PhoneNumber
          phoneNumber={phoneNumber}
          onPhoneNumberChange={setPhoneNumber}
          onStartClick={() => setCurrentStep(OnboardingStep.VerifyYourNumber)}
          onBackClick={() => setCurrentStep(OnboardingStep.Intro)}
          onboardingProgress={onboardingProgress}
        />
      )}
      {currentStep === OnboardingStep.VerifyYourNumber && (
        <VerifyYourNumber
          phoneNumber={phoneNumber}
          onStartClick={() => setCurrentStep(OnboardingStep.EnterYourDetails)}
          onBackClick={() => setCurrentStep(OnboardingStep.PhoneNumber)}
          onboardingProgress={onboardingProgress}
        />
      )}
      {currentStep === OnboardingStep.EnterYourDetails && (
        <EnterYourDetails
          onStartClick={() =>
            setCurrentStep(OnboardingStep.SelectYourAvailability)
          }
          onBackClick={() => setCurrentStep(OnboardingStep.VerifyYourNumber)}
          userData={userData}
          onUserDataChange={handleUserDataChange}
          onboardingProgress={onboardingProgress}
        />
      )}
      {currentStep === OnboardingStep.SelectYourAvailability && (
        <SelectYourAvailability
          onBackClick={() => setCurrentStep(OnboardingStep.EnterYourDetails)}
          phoneNumber={phoneNumber}
          name={userData.name}
          userName={userData.userName}
          photoURL={userData.photoURL}
          onboardingProgress={onboardingProgress}
        />
      )}
    </>
  );
};

export default OnboardingPage;
